import axios from "axios";
import auth from "../services/auth";

const baseUrl = process.env.VUE_APP_API_URL;
const api = axios.create({
  baseURL: baseUrl + "api/portal-privado/",
  withCredentials: true,
  headers: {
    "Access-Control-Allow-Credentials": true,
    "ngrok-skip-browser-warning": "1234"
  }
});
api.interceptors.request.use(async (config) => {
  let token = null;
  // let tokenDir = null;
  if (auth.isAuthenticated()) {
    token = auth.getUserLogged()?.token;
  }
  if (token) {
    config.headers.Authorization = "Bearer " + token;
  }
  // if (tokenDir) {
  //   config.headers["authorization-payment"] = "Bearer " + tokenDir;
  // }
  const csrfToken = getCookie("csrfToken");
  if (csrfToken) {
    config.headers["X-CSRF-Token"] = csrfToken;
  }
  return config;
});
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("Error en Axios: ", error);
    if (error.response.status == 429) {
      console.error(error.response.data);
    }

    if (error.response.status === 401) {
      console.error(error.response.data);
      auth.cerrarSesion();
    }
    return Promise.reject(error);
  }
);

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null;
}

export default api;
